import { render } from "./WaitingCard.vue?vue&type=template&id=10aea4c7&ts=true"
import script from "./WaitingCard.vue?vue&type=script&lang=ts"
export * from "./WaitingCard.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__